import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}
const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children,
  defaultOpen = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={`border-b border-gray-200 ${className}`} data-id="element-542">
      <button className="flex justify-between items-center w-full py-4 px-6 text-left font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-543">
        <span data-id="element-544">{title}</span>
        <ChevronDownIcon className={`h-5 w-5 text-blue-500 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-545" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-546">
        <div className="py-4 px-6" data-id="element-547">{children}</div>
      </div>
    </div>;
};
interface AccordionProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'bordered' | 'minimal';
}
const Accordion: React.FC<AccordionProps> = ({
  children,
  className = '',
  variant = 'default'
}) => {
  const variantStyles = {
    default: 'bg-white rounded-lg shadow-md',
    bordered: 'border border-gray-200 rounded-lg',
    minimal: ''
  };
  return <div className={`${variantStyles[variant]} ${className}`} data-id="element-548">{children}</div>;
};
export { Accordion, AccordionItem };
export default Accordion;